import { render, staticRenderFns } from "./GroupEditor.vue?vue&type=template&id=006bb288"
import script from "./GroupEditor.vue?vue&type=script&lang=ts"
export * from "./GroupEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports